/* eslint-disable simple-import-sort/imports */
import React, { useEffect, useState } from 'react'

import { openChat } from 'app/PylonChatBot'
import { Rights } from 'app/accountUserContextConstants'
import { useAccountUserContext } from 'app/useAccountUserContext'

import * as roleUtils from 'features/auth/utils/roleUtils'
import { SystemNavigationItem } from './SystemNavigationItem'
import { Icon } from 'ui/components/Icon'

type NavigationSupportChatButtonProps = {
    isCollapsed?: boolean
}

/**
 * Renders the "Help & Support" chat button inside the navigation.
 * The button is only visible when:
 *   1. A user is logged in
 *   2. The user is NOT a portal user
 *   3. The user has the ContactSupport right
 */
export const NavigationSupportChatButton: React.FC<NavigationSupportChatButtonProps> = ({
    isCollapsed,
}) => {
    const { user, hasRight } = useAccountUserContext()
    const [unread, setUnread] = useState(0)

    useEffect(() => {
        // hide when the page mounts
        //@ts-ignore
        window.Pylon?.('hideChatBubble')

        //@ts-ignore
        window.Pylon?.('onChangeUnreadMessagesCount', (n: number) => setUnread(n))

        // When the user closes the chat, hide the chat bubble
        //@ts-ignore
        window.Pylon?.('onHide', () => {
            //@ts-ignore
            window.Pylon?.('hideChatBubble')
        })
    }, [])
    const canRender = Boolean(
        user && !roleUtils.isPortalUser(user) && hasRight(Rights.ContactSupport)
    )

    if (!canRender) return null

    return (
        <SystemNavigationItem
            label="Help & Support"
            icon={<Icon name="HelpCircle" family="lucide" color="icon" size="m" />}
            size="s"
            isUnread={unread > 0}
            variant="ghost"
            count={unread}
            onClick={openChat}
            isCollapsed={isCollapsed}
            aria-label="Open help chat"
        />
    )
}
